import { render, staticRenderFns } from "./GoogleDriveUploadFile.vue?vue&type=template&id=5ca0d81a&scoped=true"
import script from "./GoogleDriveUploadFile.vue?vue&type=script&lang=js"
export * from "./GoogleDriveUploadFile.vue?vue&type=script&lang=js"
import style0 from "./GoogleDriveUploadFile.vue?vue&type=style&index=0&id=5ca0d81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0d81a",
  null
  
)

export default component.exports